import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@env/environment';
import { DossierService } from '@shared/services/cabinet/dossier.service';
import { ArchiveUtil } from '@shared/utils/archive.util';

const excludedRoutes: { method: string; urlPattern: RegExp }[] = [
  { method: 'GET', urlPattern: /ForUser/ },
  { method: 'GET', urlPattern: /IsDossierLibre/ },
];

export const dossierInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const shouldExclude = excludedRoutes.some(
    (route) => req.method === route.method && route.urlPattern.test(req.url),
  );

  const dossierService = inject(DossierService);
  const route = inject(ActivatedRoute);
  let headers = req.headers;

  const dateArchive = route.snapshot.queryParams['dateArchive'];
  let url = req.url;
  if (url.startsWith(environment.apiUrl.cabinet) && !headers.has('X-DOSSIER')) {
    if (!shouldExclude && dossierService.dossierId) {
      headers = headers.append(
        'X-DOSSIER',
        dossierService.dossierId.toString(),
      );
    }

    if (dossierService.password) {
      headers = headers.append('X-PASSWORD', dossierService.password);
    }

    const newUrl = new URL(req.url);
    const pathname = newUrl.pathname;
    if (dateArchive && ArchiveUtil.isAuthorized(req.method, pathname)) {
      headers = headers.append('X-DATEARCHIVE', dateArchive);
      headers = headers.append('X-NATURE', '1');
      newUrl.pathname = `Archive${pathname}`;
      url = newUrl.href;
    } else {
      headers = headers.append('X-NATURE', '0');
    }
  }

  const newReq = req.clone({
    headers,
    url,
  });
  return next(newReq);
};
